import { render, staticRenderFns } from "./BuildinLayoutLeft.vue?vue&type=template&id=0a0d1f38&scoped=true&"
import script from "./BuildinLayoutLeft.vue?vue&type=script&lang=ts&"
export * from "./BuildinLayoutLeft.vue?vue&type=script&lang=ts&"
import style0 from "./BuildinLayoutLeft.vue?vue&type=style&index=0&id=0a0d1f38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d1f38",
  null
  
)

export default component.exports